<template>
  <section>
    <Toolbar/>
     <DataTable 
      :opt="optDataTable"
      :collection="collection"
      :register="register"
      :filters="filters"
      :details="details"
      :claims="computedClaims"
      :blockedField="blockedField"
      :integration="integration"
      :dataFilters="dataFilters"
    />
  </section>
</template>

<script>
import Toolbar from "@/components/Templates/Toolbar"
import DataTable from "@/components/Registers/DataTable"
import { createNamespacedHelpers } from 'vuex'
const { mapState:registersState, mapActions:registersActions } = createNamespacedHelpers('registers')
export default {
  name: "List",
  components: { DataTable, Toolbar },
  props: {
    collection: {
      type: String,
      required: true,
    },
    register: {
      type: String,
      required: true,
    },
    filters: {
      required: false,
    },
    orderBy: {
      required: true,
    },
    details: {
      type: Array,
      required: false,
      default: () => []
    },
    blockedField: String,
    headers: {
      type: Array,
      required: false,
    },
    claims: {
      type: Object,
      required: true,
      default: () => ({
        add: false, 
        view: false, 
        edit: false, 
        delete: false, 
      })
    },
    integration: {
      type: Boolean,
      default: false
    },
    dataFilters: {
      default: () => []
    },
    inputsMaster: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...registersState(['registers']),
    optDataTable() {
      this.computedClaims
      return {
        vModel: this.vModel,
        headers: [...this.computedHeaders, /*this.status,*/ this.actions],
        items: this.registers[this.register],
        showSelect: true,
        itemKey: 'id',
        serverItemsLength: true,
        dispatch: []
      }
    },
    computedHeaders() {
      return this.inputsMaster.filter(input => input.list).map(x => {
        if (x.markers) { 
          for (const key in x.markers) { 
            if (Object.hasOwnProperty.call(x.markers, key)) {
              x.markers[key.trim().toLowerCase()] = x.markers[key]
            }
          }
        }
        return { ...x, text: x.label || x.value }
      })
    },
    status() {
      return { text: 'Sincronia', value: 'data-table-status', align: 'center', tdClass: 'text-center'}
    },
    actions() {
      return { text: 'Ações', value: 'data-table-actions', align: 'center', tdClass: 'text-center text-no-wrap' }
    },
    computedClaims() {
      const json = localStorage.getItem(process.env.VUE_APP_USERKEY)
      const userData = JSON.parse(json)

      let claims = this.claims
      
      claims.view = claims.view && (userData?.claims?.admin || userData?.rules.some(x => x.claims && x.claims[this.register] && x.claims[this.register]?.view))
      claims.add = claims.add && (userData?.claims?.admin || userData?.rules.some(x => x.claims && x.claims[this.register] && x.claims[this.register]?.add))
      claims.edit = claims.edit && (userData?.claims?.admin || userData?.rules.some(x => x.claims && x.claims[this.register] && x.claims[this.register]?.edit))
      claims.delete = claims.delete  && ( userData?.claims?.admin || userData?.rules.some(x => x.claims && x.claims[this.register] && x.claims[this.register]?.delete))
      claims.approval = claims.approval && ( userData?.claims?.admin || userData?.rules.some(x => x.claims && x.claims[this.register] && x.claims[this.register]?.approval))
      // claims.noFilters = userData?.rules.find(x => x.claims && x.claims[this.register] && x.claims[this.register]?.view)
      
      return claims
    },
  },
  methods: {
    ...registersActions(['observer']),
    initRegisters() {
      this.observer({
        collection: this.collection, 
        register: this.register, 
        filters: this.filters,
        orderBy: this.orderBy,
        details: this.details
      })
    }
  },
  created() {
    this.initRegisters()
  },
}
</script>

<style>

</style>